 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		109: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_vi","52":"lang_zh_cn","53":"lang_zh_tw","54":"locale_ak","55":"locale_ar","56":"locale_be","57":"locale_bg","58":"locale_bs","59":"locale_ca","60":"locale_cs","61":"locale_da","62":"locale_de","63":"locale_el","64":"locale_en","65":"locale_es","66":"locale_et","67":"locale_fi","68":"locale_fil","69":"locale_fr","70":"locale_he","71":"locale_hi","72":"locale_hr","73":"locale_hu","74":"locale_id","75":"locale_is","76":"locale_it","77":"locale_ja","78":"locale_ka","79":"locale_kk","80":"locale_ko","81":"locale_ky","82":"locale_lt","83":"locale_lv","84":"locale_nl","85":"locale_pa","86":"locale_pl","87":"locale_pt","88":"locale_ro","89":"locale_ru","90":"locale_sk","91":"locale_sl","92":"locale_sq","93":"locale_sr","94":"locale_sr_cyrl_me","95":"locale_sv","96":"locale_sw","97":"locale_th","98":"locale_tr","99":"locale_uk","100":"locale_ur","101":"locale_vi","102":"locale_zh","103":"loclae_af","104":"polyfills","106":"vendors~css-vars-ponyfill","107":"vendors~polyfills"}[chunkId]||chunkId) + "." + {"0":"f73a18da929ad1b890b9","2":"ade3c888e0e2071f65a0","3":"db623f40662d114f04ca","4":"773b2dc25ff0d121e459","5":"6319e697b677eea87198","6":"1ba4052c2adf005a1464","7":"fa1e6b9aac97b256d68f","8":"41a8e66071bde8f5658e","9":"987f9d6799a9493e3ec8","10":"1df9a2b6887202a7e6cd","11":"85416c934c92d233e003","12":"5b9d5a9801247a1b8622","13":"11842574be379351132d","14":"349811b4ddd5f959334a","15":"e57bdb178cd9a9294d7d","16":"114d775db3ce75068282","17":"dd60088b694ca121c34e","18":"c9412eb291fd139fac1f","19":"710e8a0f82da8a89659e","20":"3d0deb7fedd525767457","21":"70df5fc0610f1cb6ef1d","22":"6b2f53113ff9050be9f2","23":"f7c6b5e0793e5d7e4500","24":"799c6359138faf1bb86d","25":"fd1fb3bf2c857ca4ff93","26":"bbeba13671663b9ae2e6","27":"520a656b0edf94ab783d","28":"742b1958b1c7b4af4315","29":"9424a8dd714a781f5c1a","30":"1d9335e909827bdff5ae","31":"b142c91e63e98f17d73e","32":"3648c5cf3ec366f56d08","33":"bdbdf274d2369314a077","34":"162c34e1e9eb072d5177","35":"e2aaba4de36ce34f765b","36":"e5f426fd79ab21377b8f","37":"3a32a88ffb5f37fb9d06","38":"dd4fcef0efa96c7c0817","39":"5d37ea12f2d34e17d5ee","40":"aa0761e243c154d2745b","41":"4dbe2ad9f8237f013060","42":"df5fd0df0a758d02cd37","43":"7c3fc6285b8a8c4a678c","44":"c11cfb4864f98c1f3bde","45":"5e61c2b49cac0b209844","46":"dabf89eb5cb81dd276c4","47":"92d370106c361eb7b2a5","48":"7a55ddc286de01c7dac3","49":"6754d6c5dab80d0c072f","50":"0945d3b48bfcd85601e0","51":"d0efabdc1903da05ffce","52":"40b80ab821742adad43c","53":"ba6b94b8cc9d63786b5e","54":"c16312cd41187e0f4ff1","55":"7ab8ea64065b1e0c30cd","56":"00da6fc939f9b83e2dac","57":"608918c0a81830d4251d","58":"5d871561a3c4d85fcbdc","59":"8bfddeee96d1129f5366","60":"22debc636826aa3a4cb6","61":"46ebd28f3191c5b10705","62":"6b6e36578214a062f7c9","63":"a0302208db65a15e5e30","64":"2e2c8893a962b7d912cd","65":"f5c86332a54bcff4ed03","66":"426854d98f888c6f2d0a","67":"3bb10ce43086f7a25a88","68":"6371a59e55164dbfe48d","69":"62ba840ec9c4b9ebe84c","70":"be592225282927306e27","71":"37cab80a4ce7af1e33b4","72":"82a570699dced062c8b7","73":"8b7b3bd2f57a0d3a7c0a","74":"01431cb2f556a38a205f","75":"4f7ae9536a95c6132347","76":"25caf41107b65e7172ba","77":"00c69e695fa8432c6556","78":"90a37fb3d4987a2ed500","79":"534d230244de262d9eaa","80":"1f62cb2da68d41daa659","81":"2fff4e73710de6c7111f","82":"db8fe76b6f2553f80413","83":"959420c01352778f039d","84":"493326a81c049d3423ae","85":"22e612dda6efcd625ea4","86":"f731a527e902d282b67d","87":"1550b76dca6300dd8ed7","88":"2445b9aa508444a5af9b","89":"ef4c7c9d987e7c5386b4","90":"427235199885ccdf79db","91":"3f220dbc3587e43f21d8","92":"4311a31687338dd798e2","93":"e2fb8389ecdbdc7221ff","94":"209e64b0a2d0c0405c16","95":"f3ff891653ee8b458b31","96":"b8a956bf3093ec10a357","97":"3006c74e3838f8a1a85c","98":"76881bd2eb436e7b268a","99":"25e1fa913b2c21a76758","100":"a9055d5439460e838a0a","101":"31d98527bdd2a5079133","102":"3da6a76186a99f646bb4","103":"71a6bb8efcf708e0349a","104":"c24698928cbc8e3f534a","106":"5d10af83b9b4545156cd","107":"5b85049f97420b5a434b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/release-v0.1.156/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 81);
